//contentSvc.js
import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
const tokenid = localStorage.getItem("tokenid");


export const saveContentSvc = (contentObj, contentFile, callback) => {
    // console.log("saveContentSvc called, contentObj", contentObj);
    const formData = new FormData();
    formData.append("contentObj", JSON.stringify(contentObj));
    formData.append("contentFile", contentFile);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/content/save',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in saveContentSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const getContentListSvc = (callback) => {
    // console.log("getContentListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/content/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getContentListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstContent = response.data.lstContent;
            obj.contentBasePath = response.data.contentBasePath;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}
